function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import { func, node } from 'prop-types';
import SaveButton from '../SaveButton';
import FormContext from '../../context/FormContext';
/**
 * FormSubmitButton component.
 */

var FormSubmitButton = function FormSubmitButton(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["onClick", "children"]);

  var _useContext = useContext(FormContext),
      formRef = _useContext.formRef;

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(evt) {
      var formEl;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formEl = formRef.current;
              evt.preventDefault();

              if (!onClick) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return onClick();

            case 5:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var submitEvt = new Event('submit', {
                  cancelable: true
                }); // Adds a custom event listener to the form

                var listener = formEl.addEventListener('submitted', function (_ref3) {
                  var success = _ref3.detail;
                  formEl.removeEventListener('submitted', listener);

                  if (!success) {
                    reject();
                    return;
                  }

                  resolve();
                }, false);
                formRef.current.dispatchEvent(submitEvt);
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(SaveButton, _extends({}, restProps, {
    type: "submit",
    onClick: submit,
    buttonStates: {
      default: {
        text: children,
        icon: null
      },
      saving: {
        text: 'Saving',
        icon: 'kebab-h'
      },
      saved: {
        text: 'Saved',
        icon: 'tick'
      }
    }
  }));
};

FormSubmitButton.defaultProps = {
  onClick: null
};
FormSubmitButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /** On click event handler, fired before the form is submitted. */
  onClick: func,

  /** Children to use as the initial button state. */
  children: node.isRequired
} : {};
export default FormSubmitButton;